import React from 'react';
import PropTypes from 'prop-types';
import './styles.scss';

export const Text = ({ text, textAdditional, customClassText }) => (
  <div className={textAdditional ? 'container-text-additional' : ''}>
    <p className={`text ${customClassText}`}>{text}</p>
    {textAdditional && (
      <>
        <hr className="separator" />
        <p className="text-additional">{textAdditional}</p>
      </>
    )}
  </div>
);

Text.propTypes = {
  text: PropTypes.string.isRequired,
  textAdditional: PropTypes.string,
  customClassText: PropTypes.string,
};

Text.defaultProps = {
  textAdditional: '',
  customClassText: '',
};
